if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hasKlaviyoBis = this.dataset.klaviyoBis !== undefined;
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.initCustomizationToggle();

      // Set-up event listener to listen for change event in <variant-radios>
      const variantRadios = document.getElementById(`VariantRadios-${this.dataset.sectionId}`)
      if(variantRadios) {
        variantRadios.addEventListener('variantChange', this.onVariantChange.bind(this))
      }
    }

    initCustomizationToggle() {
      const buyButtonsWrapper = this.closest('.product-buy-buttons');
      if (!buyButtonsWrapper) return;

      this.customizationPanel = buyButtonsWrapper.querySelector('.product-customization');
      this.customizationOpenButton = buyButtonsWrapper.querySelector('.product-customization-button--open');
      this.customizationCloseButton = buyButtonsWrapper.querySelector('.product-customization-button--close');
      this.customizationCheckbox = buyButtonsWrapper.querySelector('.product-customization-checkbox');
      this.customizationInput = buyButtonsWrapper.querySelector('#product-customization-text-' + this.dataset.sectionId);
      this.customizationHelper = buyButtonsWrapper.querySelector('.product-customization-helper');
      this.customizationCounter = buyButtonsWrapper.querySelector('.product-customization-counter');
      this.customizationErrorMessage = buyButtonsWrapper.querySelector('.product-customization-error-message');
      this.customizationErrorText = buyButtonsWrapper.querySelector('.product-customization-error-text');
      this.customizationInputWrapper = buyButtonsWrapper.querySelector('.product-customization-form-input');
      // Visual-only preview overlay text (mirrored from the text input).
      this.customizationPreviewText = buyButtonsWrapper.querySelector('.product-customization-preview-text');

      if (!this.customizationPanel || !this.customizationOpenButton || !this.customizationCloseButton || !this.customizationCheckbox || !this.customizationInput || !this.customizationInputWrapper || !this.customizationHelper || !this.customizationCounter || !this.customizationErrorMessage || !this.customizationErrorText) return;

      // Ensure initial state: panel hidden, open button visible, close button hidden
      this.customizationPanel.classList.remove('is-open');
      this.customizationPanel.setAttribute('aria-hidden', 'true');
      this.setInert(this.customizationPanel, true);
      this.customizationOpenButton.classList.remove('hidden');
      this.customizationCloseButton.classList.add('hidden');
      this.customizationOpenButton.setAttribute('aria-expanded', 'false');
      this.customizationCloseButton.setAttribute('aria-expanded', 'false');
      this.preCustomizationSubmitDisabled = this.submitButton.disabled;
      this.preCustomizationSubmitAria = this.submitButton.getAttribute('aria-disabled');

      this.customizationOpenButton.addEventListener('click', () => {
        this.customizationPanel.classList.add('is-open');
        this.customizationPanel.setAttribute('aria-hidden', 'false');
        this.setInert(this.customizationPanel, false);
        this.customizationOpenButton.classList.add('hidden');
        this.customizationCloseButton.classList.remove('hidden');
        this.customizationOpenButton.setAttribute('aria-expanded', 'true');
        this.customizationCloseButton.setAttribute('aria-expanded', 'true');

        // When the customization UI is open, require checkbox + valid input before Add to Cart
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
      });

      this.customizationCloseButton.addEventListener('click', () => {
        this.customizationPanel.classList.remove('is-open');
        this.customizationPanel.setAttribute('aria-hidden', 'true');
        this.setInert(this.customizationPanel, true);
        this.customizationOpenButton.classList.remove('hidden');
        this.customizationCloseButton.classList.add('hidden');
        this.customizationOpenButton.setAttribute('aria-expanded', 'false');
        this.customizationCloseButton.setAttribute('aria-expanded', 'false');
        this.customizationCheckbox.checked = false;
        this.customizationInput.value = '';
        this.updateCustomizationCounter();
        this.setCustomizationError('');
        this.updateCustomizationPreviewText();

        // Restore Add to Cart button state to what it was before opening customization
        if (typeof this.preCustomizationSubmitDisabled === 'boolean') {
          this.submitButton.disabled = this.preCustomizationSubmitDisabled;
          if (this.preCustomizationSubmitAria === null) {
            this.submitButton.removeAttribute('aria-disabled');
          } else {
            this.submitButton.setAttribute('aria-disabled', this.preCustomizationSubmitAria);
          }
        }
      });

      this.customizationCheckbox.addEventListener('change', this.onCustomizationCheckboxChange.bind(this));
      this.customizationInput.addEventListener('input', this.onCustomizationInputChange.bind(this));

      this.updateCustomizationCounter();
      this.updateCustomizationPreviewText();
    }

    // Toggles `inert` on the customization panel when it is closed.
    // This prevents keyboard focus and user interaction with hidden content.
    // We prefer native `inert` when available, and fall back to setting the attribute.
    setInert(el, isInert) {
      // Prefer the native inert property when available
      if (!el) return;
      if ('inert' in el) {
        el.inert = isInert;
        return;
      }

      // Fallback for older browsers (requires inert polyfill to be meaningful)
      if (isInert) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    }

    isCustomizationActive() {
      return (
        this.customizationPanel &&
        this.customizationPanel.classList.contains('is-open') &&
        this.customizationCheckbox &&
        this.customizationCheckbox.checked
      );
    }

    onCustomizationCheckboxChange(event) {
      const checked = event.target.checked;
      // Only validate while the customization panel is open
      if (!this.customizationPanel || !this.customizationPanel.classList.contains('is-open')) return;

      if (checked) {
        // Run validation and enable Add to Cart only when valid
        const valid = this.validateCustomizationInput();
        if (valid) {
          this.submitButton.disabled = false;
          this.submitButton.setAttribute('aria-disabled', 'false');
        } else {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-disabled', 'true');
        }
      } else {
        // Checkbox unchecked: clear any validation error and keep Add to Cart disabled
        this.setCustomizationError('');
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
      }
    }

    onCustomizationInputChange() {
      // Always update the character counter while the customization input exists.
      this.updateCustomizationCounter();
      this.updateCustomizationPreviewText();

      // Only validate / gate ATC when the customization panel is open and the checkbox is checked.
      if (!this.isCustomizationActive()) return;

      const valid = this.validateCustomizationInput();
      if (valid) {
        this.submitButton.disabled = false;
        this.submitButton.setAttribute('aria-disabled', 'false');
      } else {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
      }
    }

    // Mirrors the customization text onto the image overlay preview.
    // Notes:
    // - This is visual-only: it does NOT affect cart payloads or validation rules.
    // - It mirrors the raw input value (trimmed) so users see what will be embossed.
    // - When the input is empty, the overlay text is cleared.
    updateCustomizationPreviewText() {
      if (!this.customizationPreviewText || !this.customizationInput) return;

      const value = (this.customizationInput.value || '').trim();
      this.customizationPreviewText.textContent = value;
    }

    // Validates the customization text according to business rules:
    // - required when customization is active
    // - max 7 characters
    // - limited character set (letters, numbers, & , . - ').
    // Shows localized error messages via the helper element and returns a boolean.
    validateCustomizationInput() {
      if (!this.customizationInput) return true;

      const rawValue = this.customizationInput.value || '';
      const value = rawValue.trim();

      // Required when customization is enabled
      if (value.length === 0) {
        const msg = this.customizationHelper?.dataset.errorRequired || 'Please enter customization text';
        this.setCustomizationError(msg);
        return false;
      }

      if (value.length > 7) {
        const msg = this.customizationHelper?.dataset.errorLength || 'Customization text must be 7 characters or fewer';
        this.setCustomizationError(msg);
        return false;
      }

      // Allow letters, numbers, and the special characters: & , . - '
      const pattern = /^[A-Za-z0-9&,\.\-']+$/;
      if (!pattern.test(value)) {
        const msg = this.customizationHelper?.dataset.errorCharset || 'Use only letters, numbers, and these characters: & , . - \'.';
        this.setCustomizationError(msg);
        return false;
      }

      this.setCustomizationError('');
      return true;
    }

    setCustomizationError(message) {
      if (!this.customizationHelper || !this.customizationInputWrapper) return;

      if (message) {
        this.customizationErrorText.textContent = message;
        this.customizationErrorMessage.removeAttribute('hidden');
        this.customizationCounter.setAttribute('hidden', 'true');
        this.customizationHelper.classList.add('product-customization-helper--error');
        this.customizationInputWrapper.classList.add('field-with-error');
      } else {
        // Clear error state and show character counter
        this.customizationErrorText.textContent = '';
        this.customizationErrorMessage.setAttribute('hidden', 'true');
        this.customizationCounter.removeAttribute('hidden');
        this.customizationHelper.classList.remove('product-customization-helper--error');
        this.customizationInputWrapper.classList.remove('field-with-error');
        this.updateCustomizationCounter();
      }
    }

    updateCustomizationCounter() {
      if (!this.customizationCounter || !this.customizationInput) return;

      const rawValue = this.customizationInput.value || '';
      const value = rawValue.trim();

      const max = parseInt(this.customizationInput.maxLength, 10) || parseInt(this.customizationHelper.dataset.maxCharacters, 10) || 7;
      const label = this.customizationHelper.dataset.charactersLabel || 'characters';

      const count = value.length;
      this.customizationCounter.textContent = `${count}/${max} ${label}`;
    }

    klaviyoBis() {
      if(this.klaviyoBisButton === undefined || this.klaviyoBisButton === null) {
        this.klaviyoBisButton = document.querySelector('.klaviyo-bis-trigger');
      }
      return this.klaviyoBisButton;
    }

    onVariantChange(e) {
      // Add to Cart Enabled
      if(e.detail.available === true) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.disabled = false;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.addToCart || 'Add to Cart';
        this.submitButton.classList.remove('visually-hidden');
      // Add to Cart Disabled
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.disabled = true;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.soldOut || 'Sold Out';
        if(this.klaviyoBis() !== null) {
          this.submitButton.classList.add('visually-hidden');
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // If customization is selected, enforce input validation before submitting
      if (this.isCustomizationActive()) {
        const valid = this.validateCustomizationInput();
        if (!valid) {
          return;
        }
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay-spinner').classList.remove('hidden');

      // If customization is active and we have a customization product id,
      // add both the bag and customization line items in a single request.
      const customizationVariantInput = this.form.querySelector('[name="customization_product_variant_id"]');
      const useCustomizationPayload = this.isCustomizationActive() && customizationVariantInput;

      let config;
      if (useCustomizationPayload) {
        const bagVariantInput = this.form.querySelector('[name="id"]');
        const quantityInput = this.form.querySelector('[name="quantity"]');
        const bagVariantId = bagVariantInput ? bagVariantInput.value : null;
        const customizationVariantId = customizationVariantInput.value;
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        const customizationText = (this.customizationInput?.value || '').trim();
        const title = (this.dataset.productTitle || '').trim();
        const textLineItemValue = title
          ? `${customizationText} — ${title}`
          : customizationText;

        const payload = {
          items: [
            {
              id: bagVariantId,
              quantity: quantity
            },
            {
              id: customizationVariantId,
              quantity: quantity,
              properties: {
                'Text': textLineItemValue
              }
            }
          ]
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(payload);
      } else {
        // Original single-line-item behavior using FormData (no customization, or JS-disabled path)
        config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay-spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
